module.exports = __webpack_public_path__ + "static/img/cooperative_partner_2.dc1fcd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperative_partner_2.png
// module id = 7whl
// module chunks = 0